import { AccountInfoData } from 'types';
import { getStringValue } from 'farmContext';

export const normalizeEntitlementFarmId = (
  farmId?: string | number | null,
): string | undefined => {
  const normalized = getStringValue(farmId);
  if (!normalized) {
    return undefined;
  }
  return normalized;
};

export const resolveEntitlementFarmIdFromAccount = (
  account?: AccountInfoData | null,
): string | undefined => {
  const fromSelected = normalizeEntitlementFarmId(account?.selectedFarmId);
  if (fromSelected) {
    return fromSelected;
  }

  const farms = account?.userFarms ?? [];
  if (farms.length === 1) {
    const onlyFarm = farms[0];
    return normalizeEntitlementFarmId(onlyFarm?.id ?? onlyFarm?.farmId);
  }

  return undefined;
};

export const entitlementFarmMatches = (
  expectedFarmId: string | undefined,
  account?: AccountInfoData | null,
): boolean => {
  if (!expectedFarmId) {
    return true;
  }
  const actual = normalizeEntitlementFarmId(account?.entitlementFarmId);
  return !actual || actual === expectedFarmId;
};
